import type { WorldState } from "./models/worldState.ts";

/** Deep clone for reducer drafts. GameStore clones before reduce so handlers can spread nested branches safely. */
export function cloneWorldState(state: WorldState): WorldState {
  return structuredClone(state);
}
